export { default } from './UserRoomsListContainer';



// WEBPACK FOOTER //
// ./src/components/Messenger/containers/UserRoomsListContainer/index.js